<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data" class="workflow-tabs">
                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                            
                            <div class="tab-content">
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.title")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]" :value="this.name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.description")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[description]" :value="this.description">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.sorting")}}</label>
                                            <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="this.sorting">
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="custom-control custom-switch">
                                            <input name="questionSettings[course]" type="checkbox" class="custom-control-input" id="questionSettings[course]" value="1" v-model="course">
                                            <label class="custom-control-label" for="questionSettings[course]">
                                                {{ __('views.TrainingPlans.title') }}
                                            </label>
                                        </div>                                        
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="custom-control custom-switch">
                                            <input name="questionSettings[free_request]" type="checkbox" class="custom-control-input" id="questionSettings[free_request]" value="1" v-model="free_request">
                                            <label class="custom-control-label" for="questionSettings[free_request]">
                                                {{__('forms.TrainingRequests.free_request') }}
                                            </label>
                                        </div>                                        
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="custom-control custom-switch">
                                            <input name="questionSettings[catalog]" type="checkbox" class="custom-control-input" id="questionSettings[catalog]" value="1" v-model="catalog">
                                            <label class="custom-control-label" for="questionSettings[catalog]">
                                                {{__('forms.TrainingRequests.course_to_catalog') }}
                                            </label>
                                        </div>                                        
                                    </div>
                                    
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                          <label>{{ __("forms.EvaluationChart.questions.question10.option_save") }}</label>
                                            <select class="form-control" name="questionSettings[saving_settings]" v-model="saving_settings" required>
                                                <option value="save_on_training_request">
                                                  {{ __("forms.EvaluationChart.questions.question10.save_request_table") }}
                                                </option>
                                                <option value="save_on_evaluation_chart">
                                                  {{ __("forms.EvaluationChart.questions.question10.save_request_chart") }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4 mt-3">
                                        <div class="alert alert-warning">
                                            {{__("forms.EvaluationChart.questions.question10.filter_alert")}}
                                        </div>
                                        <div class="form-group">
                                          <label>{{ __("forms.EvaluationChart.questions.question10.filter_status") }}</label>
                                          <div v-for="status in requestStatus">
                                            <input :id="status.id" v-model="filterStatus" type="checkbox" :value="status.id" name="questionSettings[status_filter][]">
                                            <label>{{status.name}}</label>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                                
                                
                                
                                <div class="row mb-3">
                                    
                                    <div class="col-12">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>{{ __('views.TrainingPlans.title') }}</th>
                                                    <th>{{ __('misc.includeInSearch') }}</th>
                                                    <th>{{ __('forms.TrainingRequests.filterAlsoInserted') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(plan) in listTrainingPlan" :key="plan.id">
                                                    <td>{{ plan.name }}</td>
                                                    <td><input type="checkbox" :value="plan.id" name="includes[training_plans][]" v-model="trainingPlans"></td>
                                                    <td><input type="checkbox" :value="plan.id" name="includesFilter[trainingPlansFilter][]" v-model="trainingPlansFilter"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>                                
                                    <div class="col-12">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>{{__('forms.TrainingRequests.course_to_catalog') }}</th>
                                                    <th>{{ __('misc.includeInSearch') }}</th>
                                                    <th>{{ __('forms.TrainingRequests.filterAlsoInserted') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(catalog) in listCatalogs" :key="catalog.id">
                                                    <td>{{ catalog.name }}</td>
                                                    <td>
                                                        <input type="checkbox" :value="catalog.id" name="includes[catalogs][]" v-model="catalogs">
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" :value="catalog.id" name="includesFilter[catalogsFilter][]" v-model="catalogsFilter">
                                                    </td>
                                                </tr>
                                            </tbody>
                                            
                                        </table>
                                    </div>
                                </div>

                                <label class="font-weight-bold">{{__('forms.TrainingRequests.training_request_structure') }}</label>

                                <div class="alert alert-warning" role="alert">
                                    {{ __("forms.EvaluationChart.questions.questions_setting.question10.alertTrainingRequestStructure") }}
                                </div>

                                <div class="row">
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>{{__('forms.TrainingRequests.min_limit') }}</label>
                                            <input class="form-control" type="number" min="0" v-model="limitMin" name="questionSettings[limitMin]">
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>{{__('forms.TrainingRequests.max_limit') }}</label>
                                            <input class="form-control" type="number" min="0" v-model="limitMax" name="questionSettings[limitMax]">
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <hr>
                                    </div>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup  >
    </div>
</template>

<script>
export default {
    
    props: {
        can_write:{
            type:Boolean,
            required:true,
        }
    },
    data () {
        return {
            saving_settings: "",
            course : 0,
            free_request : 0,
            catalog   : 0,
            listCatalogs : [],
            listTrainingPlan : [],
            trainingPlans : [],
            catalogs : [],
            includes : [],
            trainingPlansFilter: [],
            catalogsFilter: [],
            requestStatus : [],
            filterStatus : [],
            limitMin : 0,
            limitMax : 0,
            //default
            title: "Training Request",
            active : false,
            action : "",
            name:"",
            description:"",
            sorting:-1,
            editing : true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    watch: {
        limitMin(value) {
            if(value < 0) 
            this.limitMin = 0;
        },
        limitMax(value) {
            if(value < 0)
            this.limitMax = 0;
        }
    },
    methods: {
        toggle(action, item_id, editing, attributes) {
            this.active     = true;
            this.action     = action;
            this.editing    = editing;
            
            let dataRoute   = decodeURI(attributes.dataRoute);
            if (dataRoute!==undefined) {
                if (dataRoute.indexOf("[id]")>0) {
                    dataRoute = dataRoute.replace("[id]", item_id);
                }
                axios.get(dataRoute)
                .then((response) => {
                    
                    this.name = response.data.base.name;
                    this.description = response.data.base.description;
                    this.sorting = response.data.base.sorting;
                    this.course = (response.data.course === undefined) ? 0 : response.data.course;
                    this.free_request = (response.data.free_request === undefined) ? 0 : response.data.free_request ;
                    this.catalog = (response.data.catalog === undefined) ? 0 : response.data.catalog;
                    this.saving_settings = response.data.saving_settings;
                    this.requestStatus = response.data.requestStatus;
                    this.filterStatus = response.data.status_filter;
                    this.limitMin = response.data.limitMin;
                    this.limitMax = response.data.limitMax;

                    if(response.data.includes === undefined){
                        this.includes = [];
                        this.trainingPlans = [];
                        this.catalogs = [];
                        this.trainingPlansFilter = [];
                        this.catalogsFilter = [];
                    }
                    else{
                        this.includes = response.data.includes;
                        this.trainingPlans = (response.data.includes.training_plans === undefined) ? [] : response.data.includes.training_plans;
                        this.catalogs = (response.data.includes.catalogs === undefined) ? [] : response.data.includes.catalogs;
                        this.trainingPlansFilter = (response.data.includesFilter === undefined) ? [] : response.data.includesFilter.trainingPlansFilter;
                        this.catalogsFilter = (response.data.includesFilter === undefined) ? [] : response.data.includesFilter.catalogsFilter;
                    }
                    this.listCatalogs = response.data.listCatalogs;
                    this.listTrainingPlan = response.data.listTrainingPlan;
                    this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);           
                    
                });
            }
        }
        
    }
    
}
</script>

